<script setup lang="ts">
import { ErrorFallback } from '@/components/error'
import AppSidebar from '@/core/AppSidebar.vue'
import MainContainerLayout from '@/layouts/MainContainerLayout.vue'
import { HandledError } from '@/utils/errors'
import * as Sentry from '@sentry/vue'
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const pageError = ref('')
function handleError(error: Error) {
  pageError.value = error.name
  if (!(error instanceof HandledError)) {
    Sentry.captureException(error)
  }
  if (!import.meta.env.PROD && !(error instanceof HandledError)) {
    console.error(error)
  }
}

watch(route, () => {
  pageError.value = ''
})
</script>

<template>
  <main class="min-w-screen min-h-screen">
    <AppSidebar />
    <MainContainerLayout>
      <ErrorBoundary
        :key="(route.meta.rootRouteName || route.name)?.toString() + pageError"
        stop-propagation
        :on-error="handleError"
      >
        <template #boundary="{ hasError, error }: { hasError: boolean; error: Error }">
          <ErrorFallback v-if="hasError && !(error instanceof HandledError)" />
          <router-view v-else />
        </template>
      </ErrorBoundary>
    </MainContainerLayout>
    <ConfirmDialog />
    <Toast />
  </main>
</template>
